import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { color } from 'framer-motion';
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptLesson68 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code1 = (
  'text',
  `
  function Human(firstName, lastName){
    this.firstName = firstName
    this.lastName = lastName
  }
  `
  );
  const code2 = (
  'text',
  `
  function Human(firstName, lastName){
    this.firstName = firstName
    this.lastName = lastName
  }
  const person = new Human("Pete", "Attah");
  console.log(person.firstName); //Pete
  console.log(person.lastName); //Attah
  `
  );
  const code3 = (
  'text',
  `
  class Human {
    constructor(firstName, lastName){
      this.firstName = firstName;
      this.lastName = lastName
    }
  }
  const person = new Human("Pete Attah");
  console.log(person.firstName); //Pete
  console.log(person.lastName); //Attah
  `
  );
  const code4 = (
  'text',
  `
  const p = new Rectangle();
  class Rectangle {}
  `
  );
  const code5 = (
  'text',
  `
  let Rectangle = class {
    constructor(height, width){
      this.height = height;
      this.width = width
    }
  }
  console.log(Rectangle.name); //Rectangle
  `
  );
  const code6 = (
  'text',
  `
  let rectangle = class Rectangle {
    constructor(height, width){
      this.height = height;
      this.width = width
    }
  }
  console.log(rectangle.name); //Rectangle
  `
  );
  const code7 = (
  'text',
  `
  class Rectangle {
    constructor(height, width){
      this.height = height;
      this.width = width
    }

    //Setter method
    calcArea(){
      return this.height * this.width
    }

    //Getter method
    getArea(){
      return this.calcArea()
    }
  }
  const rectangle = new Rectangle(10,10);
  console.log(rectangle.getArea()); //100
  `
  );

  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <h3><strong>What is OOP?</strong></h3>
        <p>Object oriented programming (OOP) is a way of writing code that allows you to create different objects from a common object. The common object is usually called a <strong>blueprint</strong> while the created objects are called <strong>instances.</strong></p>
        <p>Each instance has properties that are not shared with other instances. For example, if we have a <strong>Human blueprint</strong>, we can create human instances with different names.</p>
        <p>The second aspect of object oriented programing is about structuring code when you have multiple levels of blueprint. This is called <strong>inheritance</strong> or <strong>subclasing</strong></p>
        <p>The third aspect of object oriented programming is about encapsulation where you hide certain piece of information with the object so they are not accessible.</p>
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>Approaches to OOP</strong></h4>
    <p>There are four (4) approaches to <strong>object oriented programing</strong> in Javascript:</p>
         <ol class="list-group list-group-numbered mb-4">
          <li class="list-group-item">Using constructor functions.</li>
          <li class="list-group-item">Using classes.</li>
          <li class="list-group-item">Using objects linking to other objects (OLO).</li>
          <li class="list-group-item">Using factory functions.</li>
        </ol>
        <h4>1. <strong>Using Constructor Functions</strong></h4>
        <p>Constructors are special functions that contain a <strong>this</strong> keyword.</p>
        <CopyBlock
        language={language}
        text={code1}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        <p><strong>this</strong> lets you store and access unique values created for each instance. You can create an instance with the <strong>new</strong> keyword.</p>
       <p>Now, let's create an instance of our <strong><em>Human class</em></strong> and access the properties.</p>
       <CopyBlock
       language={language}
       text={code2}
       showLineNumbers={lineNumbers}
       theme={dracula}
       wrapLines={true}
       codeBlock
       />
       </div>

       <div class="alert alert-secondary mt-3" role="alert">
        <h4>2. <strong>Using Classes</strong></h4>
        <p>Classes are said to be the <strong>syntactic sugar</strong> of constructor functions.</p>
        <p>They are an alternative way to writing <strong>constructor functions.</strong></p>
        <p><strong>Classes</strong> are a template for creating objects. They encapsulate data with code to work on that data.</p>
        <p>Classes in Javascript are built on prototypes but also have some syntax and sematics that are not shared with ES5 class-alike semantics.</p>
        <p>One way to define a class is to use the <strong>class</strong> keyword with the name of the class.</p>
        <CopyBlock
        language={language}
        text={code3}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        <p className="mt-3">We need to create a <b class="text-danger">constructor</b> because we want to initialize values into <b class="text-danger">this.</b> We can skip the constructor if we don't need to initialize values. </p>
        </div>

        <div class="alert alert-secondary mt-3" role="alert">
        <h4><strong>Hoisting</strong></h4>
        <p>An important difference between function declarations and class declarations is that function declarations are <strong><em>hoisted</em></strong> and class declarations are not.</p>
        <p>You first need to declare your class and then access it.</p>
        <p>The following code will throw an error.</p>
        <CopyBlock
        language={language}
        text={code4}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>

        <div class="alert alert-secondary mt-3" role="alert">
        <h4><strong>Class Expressions</strong></h4>
          <p>Class expression is another to define a class. Class expressions can be <strong>named</strong> or <strong>unamed.</strong></p>
          <p>The name given to a <strong>named class</strong> expression is local to the class' body.</p>
          <h4>Unamed class</h4>
          <CopyBlock
          language={language}
          text={code5}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
          <h4 className="mt-3">Named class</h4>
          <CopyBlock
          language={language}
          text={code6}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
        </div>

        <div class="alert alert-secondary mt-3" role="alert">
        <h4><strong>Strict Mode</strong></h4>
        <p>The body of a class is executed in strict mode. i.e., code written here is subject to stricter syntax for increased performance.</p>
        <p>Some otherwise silent errors will be thrown and certain keywords are reserved.</p>
        <p>The following example utilizes a <b class="text-danger">getter</b> and <b class="text-danger">setter</b> method.</p>
        <CopyBlock
        language={language}
        text={code7}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>




    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson68
